import React, { Component } from 'react';
import {Form, Input, Select} from "antd";

class DisputeRequestor extends Component{
    render() {
        let requestor_info = JSON.parse(window.localStorage.getItem('userInfo'))
        return <div className="spaceBox ">
                    <Form.Item
                        label="Dispute Requestor"
                        style={{fontWeight:'bold'}}
                    >
                    </Form.Item>
                    {this.props.type==10?'':
                        <Form.Item
                            label="Requestor"
                            name={'requesterId'}
                            rules={[{ required: true }]}
                            initialValue={requestor_info.requestorID}
                        >
                            <Input maxLength={50} />
                        </Form.Item>
                    }
                    {
                    this.props.type==10 || this.props.type==12?'':
                        <Form.Item
                            label="Phone Number"
                            name={'requesterPhoneNo'}
                            rules={[{ required:false}]}
                            initialValue={requestor_info.requestorPhoneNo}
                        >
                            <Input maxLength={30} />
                        </Form.Item>
                    }
                    <Form.Item
                        label="Email Address"
                        name={'requesterEmail'}
                        rules={[{ required: true }]}
                        initialValue={requestor_info.requestorEmail}
                    >
                        <Input maxLength={200} />
                    </Form.Item>
                    {this.props.type==12?'':
                        <Form.Item
                            label="Company"
                            name={'requesterCompany'}
                            rules={[{ required: true }]}
                            initialValue={requestor_info.requestorCompany}
                        >
                            <Input maxLength={255} />
                        </Form.Item>
                    }
                </div>
    }
}

export default DisputeRequestor;